import { isPerformanceAPIAvailable } from './is-performance-api-available';

export const hasPerformanceAPIAvailable: any = isPerformanceAPIAvailable();
